import React from 'react';
import styled from 'styled-components';


const CottationWhite = () => {
  return (
      <>
          <svg xmlns="http://www.w3.org/2000/svg" width="133.914" height="61.366" viewBox="0 0 133.914 61.366">
              <g id="Quote" transform="translate(-333.624 -2092.15)">
                  <path id="Path_35" data-name="Path 35" d="M10146.8,175.082l61.1-35.282V115.082h-61.1Z" transform="translate(-9812.676 1977.568)" fill="none" stroke="#fff" stroke-width="1"/>
                  <path id="Path_5761" data-name="Path 5761" d="M10146.8,175.082l61.1-35.282V115.082h-61.1Z" transform="translate(-9740.866 1977.568)" fill="none" stroke="#fff" stroke-width="1"/>
              </g>
          </svg>
      </>
  );
};


export default React.memo(CottationWhite);
